import { Currency } from "@redotech/money/currencies";
import { DEFAULT_CURRENCY, moneyFormat } from "@redotech/money/util";
import { createContext } from "react";

export interface CurrencyEnv {
  currency: Currency;
  formatCurrency(amount: number | string): string;
  setCurrency(currency: Currency): void;
  formatCurrencyFromUSD(amount: number | string): string;
}

export const default_format_Currency = (amount: string | number) =>
  moneyFormat({ amount: +amount, currency: DEFAULT_CURRENCY });

export const CurrencyContext = createContext<CurrencyEnv>({
  currency: DEFAULT_CURRENCY,
  formatCurrency: (amount) =>
    moneyFormat({ amount: +amount, currency: DEFAULT_CURRENCY }),
  setCurrency() {},
  formatCurrencyFromUSD: (amount) =>
    moneyFormat({ amount: +amount, currency: DEFAULT_CURRENCY }),
});

// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export { DEFAULT_CURRENCY } from "@redotech/money/util";
